// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_4.cjs
/* eslint-disable */
const mission = {
  "id": "humans_4",
  "campaignFactionId": "humans",
  "order": 4,
  "title": "Хлеб и весы",
  "shortTitle": "Миссия IV",
  "description": "Сними осаду Плаценции — и познакомься с теми, кто приходит до орков",
  "finalRound": 11,
  "reward": {
    "type": "chest",
    "chestId": "chest_random_epic"
  },
  "rewardIfFactionOwned": null,
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Южный загон",
      "color": "red",
      "factionId": "orcs",
      "selectedSkin": "orcs_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Дом Весов",
      "color": "orange",
      "factionId": "ventory",
      "selectedSkin": "ventory_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-10,8": "sea",
      "-9,8": "sea",
      "-8,8": "sea",
      "-7,8": "sea",
      "-6,8": "sea",
      "-5,8": "sea",
      "-4,7": "sea",
      "-3,7": "sea",
      "-2,7": "sea",
      "-1,7": "sea",
      "0,7": "sea",
      "1,7": "sea",
      "2,6": "sea",
      "3,6": "sea",
      "4,6": "sea",
      "5,6": "sea",
      "6,5": "sea",
      "7,5": "sea",
      "8,5": "sea",
      "9,4": "sea",
      "10,4": "sea",
      "-4,-5": "flag_blue",
      "-5,-4": "quarter",
      "-3,-6": "quarter",
      "-3,-5": "quarter",
      "-4,-4": "farm",
      "-5,-5": "farm",
      "-3,-4": "farm",
      "-2,-6": "farm",
      "-4,-6": "barracks",
      "-2,-5": "mine",
      "-5,-3": "mine",
      "0,5": "central_quarter_blue",
      "-1,6": "quarter",
      "1,4": "quarter",
      "0,4": "quarter",
      "-1,5": "quarter",
      "1,5": "farm",
      "1,3": "farm",
      "0,6": "farm",
      "-2,5": "farm",
      "-2,6": "farm",
      "-1,4": "barracks",
      "5,3": "flag_red",
      "4,4": "quarter",
      "6,2": "quarter",
      "5,2": "quarter",
      "6,3": "farm",
      "4,3": "farm",
      "5,4": "farm",
      "5,1": "farm",
      "4,5": "farm",
      "6,1": "barracks",
      "3,5": "ruins",
      "7,1": "ruins",
      "7,2": "ruins",
      "-4,-2": "road",
      "-3,-2": "road",
      "-3,-1": "road",
      "-2,-1": "road",
      "-2,0": "road",
      "-1,0": "road",
      "-1,1": "road",
      "0,1": "road",
      "0,2": "road",
      "1,2": "road",
      "2,2": "road",
      "3,1": "road",
      "4,1": "road",
      "-3,-3": "road",
      "-4,-3": "road",
      "-3,0": "farm",
      "-2,-2": "ruins",
      "2,1": "ruins",
      "3,0": "ruins",
      "1,-2": "super_mine",
      "0,3": "road",
      "3,3": "road",
      "3,2": "road",
      "-1,-2": "central_quarter_blue",
      "0,-2": "quarter",
      "-1,-1": "farm",
      "-1,-3": "farm",
      "0,-3": "mine",
      "1,-3": "mine",
      "-2,2": "flag_orange",
      "-3,2": "quarter",
      "-2,3": "quarter",
      "-3,3": "farm",
      "-1,2": "farm",
      "-4,2": "ruins",
      "-4,3": "ruins",
      "-8,-2": "mountain",
      "-8,-1": "mountain",
      "-7,-3": "mountain",
      "-7,-2": "mountain",
      "-7,-1": "mountain",
      "-6,-3": "mountain",
      "-6,-2": "mountain",
      "6,-3": "mountain",
      "6,-2": "mountain",
      "7,-4": "mountain",
      "7,-3": "mountain",
      "7,-2": "mountain",
      "8,-4": "mountain",
      "8,-3": "mountain",
      "-14,0": "sea",
      "-14,3": "sea",
      "-14,6": "sea",
      "-14,9": "sea",
      "-14,12": "sea",
      "-13,-1": "sea",
      "-12,14": "sea",
      "-10,-4": "sea",
      "-9,14": "sea",
      "-7,-7": "sea",
      "-6,14": "sea",
      "-4,-10": "sea",
      "-3,14": "sea",
      "-1,-13": "sea",
      "0,14": "sea",
      "2,-14": "sea",
      "3,11": "sea",
      "5,-14": "sea",
      "6,8": "sea",
      "8,-14": "sea",
      "9,5": "sea",
      "11,-14": "sea",
      "12,2": "sea",
      "14,-14": "sea",
      "14,-11": "sea",
      "14,-8": "sea",
      "14,-5": "sea",
      "14,-2": "sea",
      "-16,0": "sea",
      "-16,1": "sea",
      "-16,2": "sea",
      "-16,3": "sea",
      "-16,4": "sea",
      "-16,5": "sea",
      "-16,6": "sea",
      "-16,7": "sea",
      "-16,8": "sea",
      "-16,9": "sea",
      "-16,10": "sea",
      "-16,11": "sea",
      "-16,12": "sea",
      "-16,13": "sea",
      "-16,14": "sea",
      "-16,15": "sea",
      "-16,16": "sea",
      "-15,-1": "sea",
      "-15,16": "sea",
      "-14,-2": "sea",
      "-14,16": "sea",
      "-13,-3": "sea",
      "-13,16": "sea",
      "-12,-4": "sea",
      "-12,16": "sea",
      "-11,-5": "sea",
      "-11,16": "sea",
      "-10,-6": "sea",
      "-10,16": "sea",
      "-9,-7": "sea",
      "-9,16": "sea",
      "-8,-8": "sea",
      "-8,16": "sea",
      "-7,-9": "sea",
      "-7,16": "sea",
      "-6,-10": "sea",
      "-6,16": "sea",
      "-5,-11": "sea",
      "-5,16": "sea",
      "-4,-12": "sea",
      "-4,16": "sea",
      "-3,-13": "sea",
      "-3,16": "sea",
      "-2,-14": "sea",
      "-2,16": "sea",
      "-1,-15": "sea",
      "-1,16": "sea",
      "0,-16": "sea",
      "0,16": "sea",
      "1,-16": "sea",
      "1,15": "sea",
      "2,-16": "sea",
      "2,14": "sea",
      "3,-16": "sea",
      "3,13": "sea",
      "4,-16": "sea",
      "4,12": "sea",
      "5,-16": "sea",
      "5,11": "sea",
      "6,-16": "sea",
      "6,10": "sea",
      "7,-16": "sea",
      "7,9": "sea",
      "8,-16": "sea",
      "8,8": "sea",
      "9,-16": "sea",
      "9,7": "sea",
      "10,-16": "sea",
      "10,6": "sea",
      "11,-16": "sea",
      "11,5": "sea",
      "12,-16": "sea",
      "12,4": "sea",
      "13,-16": "sea",
      "13,3": "sea",
      "14,-16": "sea",
      "14,2": "sea",
      "15,-16": "sea",
      "15,1": "sea",
      "16,-16": "sea",
      "16,-15": "sea",
      "16,-14": "sea",
      "16,-13": "sea",
      "16,-12": "sea",
      "16,-11": "sea",
      "16,-10": "sea",
      "16,-9": "sea",
      "16,-8": "sea",
      "16,-7": "sea",
      "16,-6": "sea",
      "16,-5": "sea",
      "16,-4": "sea",
      "16,-3": "sea",
      "16,-2": "sea",
      "16,-1": "sea",
      "16,0": "sea"
    },
    "units": [
      {
        "id": "u_blue_0_-3_-5",
        "hexKey": "-3,-5",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_blue_1_-4_-4",
        "hexKey": "-4,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_2_-3_-3",
        "hexKey": "-3,-3",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_3_-3_-2",
        "hexKey": "-3,-2",
        "ownerId": "player_id_blue",
        "type": "unit_d8",
        "size": 4,
        "maxSize": 8
      },
      {
        "id": "u_blue_4_0_4",
        "hexKey": "0,4",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      },
      {
        "id": "u_blue_5_-1_5",
        "hexKey": "-1,5",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 3,
        "maxSize": 6
      },
      {
        "id": "u_red_6_2_3",
        "hexKey": "2,3",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_red_7_2_4",
        "hexKey": "2,4",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_red_8_3_4",
        "hexKey": "3,4",
        "ownerId": "player_id_red",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_red_9_2_2",
        "hexKey": "2,2",
        "ownerId": "player_id_red",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_red_10_4_2",
        "hexKey": "4,2",
        "ownerId": "player_id_red",
        "type": "unit_d12",
        "size": 10,
        "maxSize": 12
      },
      {
        "id": "u_orange_11_-3_2",
        "hexKey": "-3,2",
        "ownerId": "player_id_orange",
        "type": "unit_d8",
        "size": 6,
        "maxSize": 8
      }
    ],
    "specialBuildings": {
      "0,4": "fortress",
      "-1,6": "warehouse",
      "-3,2": "guild"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "militarism",
      "name": "Милитаризм",
      "description": "Увеличенный урон в ближнем бою",
      "implemented": true
    },
    {
      "id": "despotism",
      "name": "Деспотизм",
      "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
      "implemented": true
    },
    {
      "id": "patriotism",
      "name": "Патриотизм",
      "description": "Скидка на найм размера отрядов и Арсенал",
      "implemented": true
    },
    {
      "id": "fortificationism",
      "name": "Фортификационизм",
      "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
      "implemented": true
    },
    {
      "id": "industrialism",
      "name": "Индустриализм",
      "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
      "implemented": true
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Презирай деньги, Луций, но плати вовремя. Деньги — обоз войны, не её оружие: ни одна монета ещё не взяла ни одной стены. Города берут железом, держат — верностью. Кто говорит тебе иное — торговец, а торговца слушай, только когда покупаешь мула. — М. Аврелий Скавр, сыну»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc.png"
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h4_break_siege",
        "type": "destroy_all_enemy_units",
        "params": {
          "color": "red"
        },
        "text": "Сними осаду — уничтожь Южный загон до конца 11-го раунда",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h4_escort_caravan",
        "type": "survive_rounds",
        "params": {
          "rounds": 11
        },
        "text": "Проводи караван Дома Весов — продержись 11 раундов",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h4_coins",
        "type": "reach_coins",
        "params": {
          "amount": 40
        },
        "text": "Собери 40 монет к шестому раунду",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h4_keep_placentia",
        "type": "keep_city",
        "params": {
          "centralHexKey": "0,5"
        },
        "text": "Удержи Плаценцию",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_5_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h4_lose_placentia",
        "type": "lose_city",
        "params": {
          "centralHexKey": "0,5"
        },
        "text": "Плаценция не должна пасть",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_6_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_red",
          "hexKey": "5,3"
        }
      }
    },
    {
      "id": "entry_7_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_red",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_8_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_orange",
          "hexKey": "-2,2"
        }
      }
    },
    {
      "id": "entry_9_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_orange",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_10_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 0,
          "currentPlayerId": "player_id_orange",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_11_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_12_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_13_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_14_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_15_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_16_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_17_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,2",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_18_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_19_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_20_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_21_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_22_SET_HEX_TOKEN",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_HEX_TOKEN",
        "payload": {
          "key": "-3,4",
          "tokenType": "farm",
          "price": 3,
          "isCommiting": false,
          "isFreeAction": false
        }
      }
    },
    {
      "id": "entry_23_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_24_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_25_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_26_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_27_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_28_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_29_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_30_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_31_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_32_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_33_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_34_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_35_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_36_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_37_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_38_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_39_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_40_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_41_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,2",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_42_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_43_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_44_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_45_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_46_SET_HEX_TOKEN",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_HEX_TOKEN",
        "payload": {
          "key": "-2,4",
          "tokenType": "farm",
          "price": 3,
          "isCommiting": false,
          "isFreeAction": false
        }
      }
    },
    {
      "id": "entry_47_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_48_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_49_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_50_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_51_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_52_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_53_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_54_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_55_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_56_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_57_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_58_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_59_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, впереди стоянка. Не орки, не наши… Повозки, весы какие-то на треногах. И очередь, легат. Посреди войны — ОЧЕРЕДЬ.",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_dozorny.png"
      }
    },
    {
      "id": "e_60_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат Луций Аврелий Скавр. Сын Марка, внук Гнея. Виктимулы — изящно, Верцеллы — дорого, но убедительно. Дом Весов приветствует восходящий актив.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_vessano_polite.png"
      }
    },
    {
      "id": "e_61_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ты знаешь меня. Я тебя — нет. Это поправимо: кто ты и что ты делаешь на римской дороге?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_lucius_stern.png"
      }
    },
    {
      "id": "e_62_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Синдик Вессано иль Морро, Дом Весов, к вашим услугам. Что делаю? Торгую, легат. Зерно, инструмент, долги, будущее. Война — неудобство для всех; мы делаем её… переносимой. Спросите очередь.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_vessano_polite.png"
      }
    },
    {
      "id": "e_63_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, глянь на их сторожей. Скучают. Посреди орочьей войны — СКУЧАЮТ. Знаешь, сколько стоит такая скука? Дороже нашего легиона.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_barba_grim.png"
      }
    },
    {
      "id": "e_64_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Откуда вы пришли, синдик? Таких, как ты, я не видел даже на восточных рынках.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_lucius_stern.png"
      }
    },
    {
      "id": "e_65_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "О, мы издалека. Так далеко, что вашим картам это покажется поэзией. Не тревожьтесь, легат: мы не воюем. Никогда и ни с кем. Это невыгодно нам — и, поверьте, ещё невыгоднее тем, с кем мы не воюем.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_vessano_polite.png"
      }
    },
    {
      "id": "entry_66_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_67_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_68_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_69_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_70_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_71_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_72_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,2",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_73_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_74_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_75_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_76_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_77_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_78_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_79_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_80_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_81_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_9_2_2",
          "unitType": "unit_d6",
          "newHexKey": "1,2"
        }
      }
    },
    {
      "id": "entry_82_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_9_2_2",
          "fromHexKey": "2,2",
          "toHexKey": "1,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_83_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_2_3",
          "unitType": "unit_d10",
          "newHexKey": "2,2"
        }
      }
    },
    {
      "id": "entry_84_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_2_3",
          "fromHexKey": "2,3",
          "toHexKey": "2,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_85_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_86_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_87_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_88_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_89_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_90_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_91_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_92_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_93_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Жар третий день. Лекарь обоза говорит — до Плаценции не довезём. Он не мечется даже. Лежит и считает.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_ilva_grief.png"
      }
    },
    {
      "id": "e_94_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…восемьсот сорок один… восемьсот сорок два… мама, полоз стёрся… я тяну, тяну…",
        "characterName": "Ансгар",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_ansgar_fever.png"
      }
    },
    {
      "id": "e_95_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Грека моего — сюда. Мальчика — в мою телегу, там сухо. Всё, исполнять.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_lucius_quiet.png"
      }
    },
    {
      "id": "e_96_replica",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Каша стынет, легат.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_barba_tender.png"
      }
    },
    {
      "id": "entry_97_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_98_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_99_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_100_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_101_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_102_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_103_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-1,2",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_104_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_105_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_106_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_107_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_108_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_109_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_110_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_111_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_112_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_9_2_2",
          "unitType": "unit_d6",
          "newHexKey": "0,2"
        }
      }
    },
    {
      "id": "entry_113_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_9_2_2",
          "fromHexKey": "1,2",
          "toHexKey": "0,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_114_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_2_3",
          "unitType": "unit_d10",
          "newHexKey": "1,2"
        }
      }
    },
    {
      "id": "entry_115_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_2_3",
          "fromHexKey": "2,2",
          "toHexKey": "1,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "e_116_objective",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "kind": "objective",
      "objective": {
        "id": "h4_break_blockade",
        "type": "destroy_unit",
        "params": {
          "unitId": "u_red_9_2_2"
        },
        "text": "Сбей заслон загона с дороги к воротам Плаценции",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "entry_117_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_118_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_119_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_120_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_121_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_122_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_123_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_124_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_125_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_126_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_127_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_128_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_129_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_130_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_131_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_132_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_133_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_134_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_135_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_136_SET_HEX_TOKEN",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_HEX_TOKEN",
        "payload": {
          "key": "-1,3",
          "tokenType": "farm",
          "price": 3,
          "isCommiting": false,
          "isFreeAction": false
        }
      }
    },
    {
      "id": "entry_137_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_138_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_139_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_140_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_141_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_142_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_143_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_144_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_145_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_146_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_147_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_148_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_149_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_150_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_151_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_152_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_153_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_154_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_155_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_156_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_157_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_158_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_159_replica",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Сорок тысяч сестерциев — и обозы зерна ваши, легат. Приятно иметь дело с человеком, который умеет собрать сумму в срок. Позвольте маленький профессиональный восторг: вы взяли её с рудника, который сами же и отбили. Оборотистость. В Риме это редкость — там предпочитают наследовать.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_vessano_polite.png"
      }
    },
    {
      "id": "e_160_replica",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Зерно пойдёт в Плаценцию. Всё. И, синдик, — города НЕ продаются.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_lucius_stern.png"
      }
    },
    {
      "id": "e_161_replica",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Разумеется, легат. Города не продаются. Города — ЗАКЛАДЫВАЮТСЯ. Это совсем другая операция, и не вы будете её стороной… Хорошего похода. Мы ещё увидимся — в очереди больших дел.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_vessano_polite.png"
      }
    },
    {
      "id": "e_162_replica",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Господин. Я выкупила у них двоих наших детей. Третьего не отдали. «Контракт». У них всё законно, господин. Орки хотя бы не показывают расписку.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_ilva_grief.png"
      }
    },
    {
      "id": "entry_163_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_164_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_165_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_166_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_167_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_168_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_169_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_170_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_171_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_172_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_173_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_174_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_175_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_176_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_177_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_178_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_179_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_180_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_181_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_182_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_183_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_184_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_185_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_186_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_187_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_188_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_189_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_190_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_191_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_10_4_2",
          "unitType": "unit_d12",
          "newHexKey": "4,1"
        }
      }
    },
    {
      "id": "entry_192_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_10_4_2",
          "fromHexKey": "4,2",
          "toHexKey": "4,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_193_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_194_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_195_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_196_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_197_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_198_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_199_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_200_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_201_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат! Почта с юга — от МАРИЯ, легат. Лично тебе.",
        "characterName": "Требоний",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_trebonius.png"
      }
    },
    {
      "id": "e_202_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Легат. Мне доносят, ты умеешь отступать. Это редкость: наступать умеют все. Ещё доносят, что ты кормишь варваров и слушаешь бабу с востока. Продолжай — я всю жизнь слушал тех, кого сенат не слушает, потому и жив. Западных зверей я запру у Секстиевых Вод. Держи север, мальчик. Юг я как-нибудь сам. — Г. Марий, консул».",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_lucius_quiet.png"
      }
    },
    {
      "id": "e_203_replica",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Как-нибудь сам»… Узнаю. Вся жизнь — «как-нибудь сам». Таких, как Марий, боги делают поштучно, мальчик. И — вот беда — не делают запасных.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_barba_grim.png"
      }
    },
    {
      "id": "entry_204_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "4,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_205_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_206_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_207_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_208_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_209_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_210_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_211_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_212_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_213_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_214_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_215_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_216_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_217_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_218_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_219_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_10_4_2",
          "unitType": "unit_d12",
          "newHexKey": "3,1"
        }
      }
    },
    {
      "id": "entry_220_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_10_4_2",
          "fromHexKey": "4,1",
          "toHexKey": "3,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_221_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_222_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_223_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_224_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_225_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_226_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_227_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_228_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_229_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "3,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_230_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_231_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_232_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_233_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_234_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_235_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_236_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_237_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_238_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_239_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_240_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_241_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_242_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_243_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_244_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_10_4_2",
          "unitType": "unit_d12",
          "newHexKey": "2,2"
        }
      }
    },
    {
      "id": "entry_245_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_10_4_2",
          "fromHexKey": "3,1",
          "toHexKey": "2,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_246_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_247_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_248_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_249_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_250_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_251_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_252_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_253_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_254_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_255_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_256_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_257_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_258_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_259_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_260_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_261_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_262_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_263_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_264_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_265_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_266_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_267_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_268_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_269_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_270_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_271_replica",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "kind": "replica",
      "replica": {
        "text": "Осада снята, легат. Загон рассеян; Плаценция открывает ворота. Палисад мы вскрыли по-гномьи, сапой. Датри бы фыркнул. Значит, одобрил бы.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_atilius_calm.png"
      }
    },
    {
      "id": "e_272_replica",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "kind": "replica",
      "replica": {
        "text": "Поздравляю с победой, легат. Позвольте прощальную любезность — бесплатную, что для меня почти интимно. Зерно этого года УЖЕ куплено. Всё. От Сицилии до Кампании. Не мной — Домом. Когда в Риме станет голодно — а станет, — вспомните: мы не воюем. Мы просто оказываемся нужны. До встречи в Риме, сын Марка.",
        "characterName": "Вессано",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m4_vessano_close.png"
      }
    },
    {
      "id": "e_273_replica",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "kind": "replica",
      "replica": {
        "text": "Квинт. Вот теперь мне страшно. Не тогда, под рёв. Сейчас.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_lucius_doubt.png"
      }
    },
    {
      "id": "e_274_replica",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "kind": "replica",
      "replica": {
        "text": "Правильно, мальчик. Рёв — он снаружи. А этот… этот в кошеле заводится. Оружие хоть ВИДНО.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m4_barba_grim.png"
      }
    },
    {
      "id": "entry_275_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_276_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_277_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_278_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_279_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_280_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_281_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,3",
          "unitId": "u_red_10_4_2",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_282_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,3",
          "unitId": "u_red_6_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_283_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,4",
          "unitId": "u_red_7_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_284_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_red_8_3_4",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_285_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_9_2_2",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_286_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_287_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-3,3",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_288_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "-2,4",
          "unitId": "u_orange_11_-3_2",
          "unitHexKey": "-3,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_289_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_290_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_291_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_292_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_293_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_294_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_295_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_296_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_297_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_298_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_299_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_300_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_301_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_302_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 11,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_303_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h4_break_siege",
      "type": "destroy_all_enemy_units",
      "params": {
        "color": "red"
      },
      "text": "Сними осаду — уничтожь Южный загон до конца 11-го раунда",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h4_escort_caravan",
      "type": "survive_rounds",
      "params": {
        "rounds": 11
      },
      "text": "Проводи караван Дома Весов — продержись 11 раундов",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h4_coins",
      "type": "reach_coins",
      "params": {
        "amount": 40
      },
      "text": "Собери 40 монет к шестому раунду",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h4_keep_placentia",
      "type": "keep_city",
      "params": {
        "centralHexKey": "0,5"
      },
      "text": "Удержи Плаценцию",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h4_lose_placentia",
      "type": "lose_city",
      "params": {
        "centralHexKey": "0,5"
      },
      "text": "Плаценция не должна пасть",
      "isMain": false,
      "isFailure": true
    },
    {
      "id": "h4_break_blockade",
      "type": "destroy_unit",
      "params": {
        "unitId": "u_red_9_2_2"
      },
      "text": "Сбей заслон загона с дороги к воротам Плаценции",
      "isMain": false,
      "isFailure": false
    }
  ]
};

export default mission;
